import { CloudOff, Send } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'
import * as m from '~/paraglide/messages'
import { getErrorMessageFromError } from '~/shared/lib/api-errors'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~/shared/ui/alert-dialog'
import { Button } from '~/shared/ui/button'

/** Puts a profile or place in public, or takes it offline after asking. */
export function PublishControl({
  name,
  published,
  busy,
  onChange,
}: {
  name: string
  published: boolean
  busy: boolean
  onChange: (published: boolean) => Promise<unknown>
}) {
  const [confirming, setConfirming] = useState(false)

  const change = async (next: boolean) => {
    try {
      await onChange(next)
      toast.success(next ? m.publishedDone() : m.takenOfflineDone())
    } catch (error) {
      toast.error(getErrorMessageFromError(error))
    }
  }

  if (!published) {
    return (
      <Button disabled={busy} onClick={() => change(true)}>
        <Send />
        {m.publish()}
      </Button>
    )
  }

  return (
    <>
      <Button variant="outline" disabled={busy} onClick={() => setConfirming(true)}>
        <CloudOff />
        {m.takeOffline()}
      </Button>
      <AlertDialog open={confirming} onOpenChange={setConfirming}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{m.takeOfflineTitle({ name })}</AlertDialogTitle>
            <AlertDialogDescription>{m.takeOfflineDescription()}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{m.cancel()}</AlertDialogCancel>
            <AlertDialogAction onClick={() => change(false)}>{m.takeOffline()}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
